var $358887a270e447e0$exports = {};
$358887a270e447e0$exports = {
    "valid": `Kehtiv`
};


export {$358887a270e447e0$exports as default};
//# sourceMappingURL=et-EE.mjs.map
